import classNames from "classnames";
import { useField } from "formik";
import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../Icon/Icon";
import "./FormInput.css";

// JSDoc cannot handle a forwardRef, so we have some ts-ignores

/**
 *  @param {*} props
 *  @prop {string} label
 *  @prop {string} name
 */
// @ts-ignore
export const FormInput = forwardRef(({ label, ...props }, ref) => {
  const { t } = useTranslation();

  // @ts-ignore
  const [field, meta] = useField(props);

  const hasInput = meta.value !== "";
  const hasError = !!meta.error;

  return (
    <div
      className={classNames("FormInput", {
        "has-error": hasError,
        "has-input": hasInput,
      })}
    >
      <label className="FormInput__label">
        {t(label)}
        <div className="FormInput__input-wrapper">
          <input {...field} {...props} ref={ref} className="FormInput__input" />

          {hasError && (
            <Icon
              className="FormInput__error-icon"
              name="iconNotification"
              width={20}
              height={20}
            />
          )}
        </div>
      </label>
      <div className="FormInput__error-message">{t(meta.error)}</div>
    </div>
  );
});
